/**
 * Labstep
 *
 * @module components/ResourceLocation/EmptyState
 * @desc Empty state for ResourceLocation
 */

import { ResourceLocationActionCreate } from 'labstep-web/components/ResourceLocation/Action/Create';
import { ResourceLocationActionCreateSub } from 'labstep-web/components/ResourceLocation/Action/CreateSub';
import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import { ResourceLocation } from 'labstep-web/models/resource-location.model';
import type React from 'react';
import type { IResourceSubLocationEmptyStateProps } from './types';

export const ResourceSubLocationEmptyState: React.FC<
  IResourceSubLocationEmptyStateProps
> = (props) => (
  <CardEmptyState
    src="/img/empty-state/locations.svg"
    title="No sub-locations"
    explanation="Add sub-locations to allow more granular specification of item locations."
    action={<ResourceLocationActionCreateSub {...props} />}
  />
);

export const ResourceLocationEmptyState: React.FC = () => (
  <CardEmptyState
    src="/img/empty-state/locations.svg"
    title={`No ${ResourceLocation.getHumanReadableEntityName(
      true,
      true,
    )}`}
    explanation="Use resource locations to manage the storage locations used by this workspace. You can use these to indicate the location of your resource items in your inventory."
    action={<ResourceLocationActionCreate />}
  />
);
